export default {
  'urban_coverage_census_tract': 'censusTractPixelValue',
  'urban_coverage_slum': 'slumPixelValue',
  'urban_coverage_slope': 'slopePixelValue',
  'urban_coverage_risk': 'riskPixelValue',
  'urban_coverage_hand': 'handPixelValue',
  'urban_periods_main': 'periodsPixelValue',
};
